import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import AdminFamilySelect from "components/creation/AdminFamilySelect";
import PersonalizedTasks from "components/tasks/PersonalizedTasks";
import { Family } from "protogen/advisors_service_pb";
import FlexPage from "components/layout/FlexPage";
import { DesktopCardWrapper } from "pages/MemberHome";
import { useSearchParams } from "react-router-dom";
import { useGetFamilyDetails } from "services/advisor";

export default () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedFamily, setSelectedFamily] = useState<Family | null>(null);

  const { request: getFamilyDetails } = useGetFamilyDetails();

  useEffect(() => {
    const loadFamily = async () => {
      const response = await getFamilyDetails({
        familyRef: searchParams.get("familyRef") || "",
      });
      if (response?.family) {
        setSelectedFamily(response.family);
      }
    };
    if (searchParams.get("familyRef")) {
      loadFamily();
    }
  }, []);

  const handleFamilyChange = (
    familyRef: string | null,
    family?: Family | null,
  ) => {
    setSelectedFamily(family || null);

    // Update URL query parameter
    if (familyRef) {
      setSearchParams({ familyRef });
    } else {
      setSearchParams({});
    }
  };

  return (
    <FlexPage>
      <Box display="flex" flexDirection="column" gap="32px" maxWidth="650px">
        <Typography variant="display">Personalized Tasks Tester</Typography>

        <Box>
          <Typography variant="h3" sx={{ marginBottom: "16px" }}>
            Select a Family
          </Typography>
          <AdminFamilySelect
            selectedFamily={selectedFamily?.ref || null}
            onChange={handleFamilyChange}
            title="Select Family"
          />
        </Box>

        {selectedFamily && (
          <DesktopCardWrapper>
            <PersonalizedTasks family={selectedFamily} />
          </DesktopCardWrapper>
        )}
      </Box>
    </FlexPage>
  );
};
